import * as React from 'react'

import { COMPONENT_ICONS, isComponentIconName } from './componentIcons'
import { IconGlyph } from './IconGlyph'
import type { IconName } from './iconName'
import type { IconsModule } from './icons'

type PickerIconProps = {
  icon: IconName
  /** Loaded glyph map; null while the lazy chunk is pending. */
  icons: IconsModule | null
  /** Rendered pixel size. */
  size: number
}

/**
 * Renders a picker icon by kind: a channel/integration icon reuses its Popcorn
 * component; every other name renders the curated glyph's geometry. Both inherit
 * the container's `currentColor`, so the selected tint applies uniformly.
 *
 * @internal Shared by the picker trigger, grid cells, and `IconTile`.
 */
export function PickerIcon({
  icon,
  icons,
  size,
}: PickerIconProps): React.JSX.Element | null {
  if (isComponentIconName(icon)) {
    const Icon = COMPONENT_ICONS[icon]
    return <Icon size={size} aria-hidden />
  }
  // Eliminating the component-icon members narrows `icon` to a glyph name, so it
  // safely indexes the glyph map (channel/integration icons have no geometry).
  return <IconGlyph icon={icon} glyph={icons?.[icon]} size={size} />
}
